export default "__VITE_ASSET__f52e35a5__"